import { render, staticRenderFns } from "./CatchUps.vue?vue&type=template&id=0784d743&scoped=true"
import script from "./CatchUps.vue?vue&type=script&lang=js"
export * from "./CatchUps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0784d743",
  null
  
)

export default component.exports